module.exports = __webpack_public_path__ + "img/id-correct-frontside.3b5891f6.png";